import request from '@/utils/request'
import wechattype from '../utils/environment'

export function wxCodeInfo (code) {
  // 登录
  if (wechattype) {
    return request({
      url: '/wxService/wxCodeInfo/' + code,
      method: 'get'
    })
  } else {
    return request({
      url: '/aliService/aliCodeInfo/' + code,
      method: 'get'
    })
  }

}

export function selectDept (data) {
  // 科室列表
  return request({
    url: '/wx/select',
    method: 'get'
  })
}
export function selectByPaiBan (data) {
  // 科室列表
  return request({
    url: '/wx/selectByPaiBan',
    method: 'get'
  })
}

export function addPatient (data) {
  const formData = new FormData()
  for (let i in data) {
    formData.append(i, data[i])
  }
  // 添加就诊人
  if (wechattype) {
    return request({
      url: '/wx/mine/addPatient?clientType=WX',
      method: 'post',
      data: formData
    })
  } else {
    return request({
      url: '/wx/mine/addPatient?clientType=ALI',
      method: 'post',
      data: formData
    })
  }

}
export function getCode (data) {
  // 获取验证码
  return request({
    url: '/wx/mine/getCode?str=' + data.str,
    method: 'get'
  })
}
export function getPatient () {
  // 就诊人列表
  if (wechattype) {
    return request({
      url: '/wx/mine/getPatient?clientType=WX',
      method: 'get'
    })
  } else {
    return request({
      url: '/wx/mine/getPatient?clientType=ALI',
      method: 'get'
    })
  }

}
export function deletePatient (data) {
  // 删除就诊人
  return request({
    url: '/wx/mine/deletePatient/' + data,
    method: 'delete'
  })
}
export function setPatient (data) {
  // 设为默认就诊人
  if (wechattype) {
    return request({
      url: '/wx/mine/setUp?clientType=WX&patientId=' + data,
      method: 'get'
    })
  } else {
    return request({
      url: '/wx/mine/setUp?clientType=ALI&patientId=' + data,
      method: 'get'
    })
  }

}

export function getDefaultPatient () {
  // 获取默认就诊人
  if (wechattype) {
    return request({
      url: '/wx/mine/getDefaultPatient?clientType=WX',
      method: 'get'
    })
  } else {
    return request({
      url: '/wx/mine/getDefaultPatient?clientType=ALI',
      method: 'get'
    })
  }

}

export function findByDoctor (data) {
  // 医生详细信息
  if (wechattype) {
    return request({
      url: `/wx/wxSectionDoctor/findByDoctor?doctorCode=${data}&clientType=WX`,
      method: 'get',
    })
  } else {
    return request({
      url: `/wx/wxSectionDoctor/findByDoctor?doctorCode=${data}&clientType=ALI`,
      method: 'get'
    })
  }

}

export function getFollow (name) {
  // 获取关注列表
  if (wechattype) {
    return request({
      url: '/wx/mine/getFollow?clientType=WX&doctorName=' + name,
      method: 'get'
    })
  } else {
    return request({
      url: '/wx/mine/getFollow?clientType=ALI&?doctorName=' + name,
      method: 'get'
    })
  }

}

export function deleteFollow (docid) {
  // 取消关注
  if (wechattype) {
    return request({
      url: `/wx/mine/deleteFollow?doctorId=${docid}&clientType=WX`,
      method: 'delete'
    })
  } else {
    return request({
      url: `/wx/mine/deleteFollow?doctorId=${docid}&clientType=ALI`,
      method: 'delete'
    })
  }
}

export function addFollow (docid) {
  // 关注
  if (wechattype) {
    return request({
      url: `/wx/mine/addFollow?doctorId=${docid}&clientType=WX`,
      method: 'post'
    })
  } else {
    return request({
      url: `/wx/mine/addFollow?doctorId=${docid}&clientType=ALI`,
      method: 'post'
    })
  }
}

export function findBySectionId (data) {
  // 获取医生列表
  return request({
    url: '/wx/wxSectionDoctor/findBySectionId',
    method: 'post',
    data: data
  })
}

export function getTempPaiBanInfo (data) {
  // 获取医生列表
  return request({
    url: '/wx/wxSectionDoctor/getPaiBanInfo',
    method: 'post',
    data: data
  })
}

export function unallowedOrders (data) {
  // 获取医生已被预约的时间
  return request({
    url: '/wx/UnallowedOrders',
    method: 'post',
    data: data
  })
}

export function createOrder (data) {
  // 创建订单
  if (wechattype) { // 微信
    if (data.yb) { // 微信医保
      const newData = { ...data, payType: 3 }
      return request({
        url: '/wx/order/create',
        method: 'post',
        data: newData
      })
    } else { // 微信自费
      const newData = { ...data, payType: 1 }
      return request({
        url: '/wx/order/create',
        method: 'post',
        data: newData
      })
    }
  } else { // 支付宝
    if (data.yb) { // 支付宝医保
      const newData = { ...data, payType: 4 }
      return request({
        url: '/wx/order/create',
        method: 'post',
        data: newData
      })
    } else { // 支付宝自费
      const newData = { ...data, payType: 2 }
      return request({
        url: '/wx/order/create',
        method: 'post',
        data: newData
      })
    }
  }
}

export function findOrderInfoByPatient (data) {
  // 获取缴费信息
  return request({
    url: '/wx/findOrderInfoByPatient',
    method: 'post',
    data: data
  })
}

export function getPayment (id) {
  // 获取支付参数
  return request({
    url: '/wx/order/payment/' + id,
    method: 'get'
  })
}

export function refund (id) {
  // 核酸退款退号
  return request({
    url: '/wx/hstf/order/refund/' + id,
    method: 'get'
  })
}

// 退款
export function refundorder (query) {
  return request({
    url: '/refund/order/refund/',
    method: 'get',
    params: query
  })
}


export function findDoctorBySectionOrName (name) {
  // 获取支付参数
  return request({
    url: '/wx/wxSectionDoctor/findDoctorBySectionOrName?index=' + name,
    method: 'get'
  })
}

export function getAliPayForm (id) {
  // 获取支付bao参数
  return request({
    url: '/aliService/getAliPayForm/' + id,
    method: 'get'
  })
}

export function payTest (id) {
  // 获取支付bao参数
  return request({
    url: '/aliService/testsaoma/' + id,
    method: 'get'
  })
}

export function pushOrderRegToHIS (id) {
  // 查询挂号
  return request({
    url: 'wx/order/pushOrderRegToHIS/' + id,
    method: 'get'
  })
}

export function getHisPrescription (data) {
  // 获取就诊人处方信息
  return request({
    url:
      '/wx/order/getExtFeeList?patientId=' +
      data.patientId +
      '&queryType=' +
      data.queryType,
    method: 'get'
  })
}

export function createRecipe (data) {
  // 创建处方订单
  if (wechattype) {
    const newData = { ...data, payType: 1 }
    return request({
      url: '/wx/order/createRecipe',
      method: 'post',
      data: newData
    })
  } else {
    const newData = { ...data, payType: 2 }
    return request({
      url: '/wx/order/createRecipe',
      method: 'post',
      data: newData
    })
  }
}

export function reg (data, type) {
  // 核酸检测绑定病案号
  return request({
    url: '/wx/nucleate/reg/' + data + '/' + type,
    method: 'get'
  })
}

export function putHrmOrder (data) {
  // 创建核酸订单
  return request({
    url: '/wx/nucleate/putHrmOrder',
    method: 'post',
    data: data
  })
}

// 获取核酸缴费列表
export function getHrmOrder (data) {
  return request({
    url: '/wx/nucleate/getHrmOrder/' + data.mrNo + '/' + data.type,
    method: 'get'
  })
}

// 核酸结果查询
export function getMedLisRpt (data) {
  return request({
    url: '/wx/nucleate/getMedLisRpt/' + data,
    method: 'get'
  })
}

// 获取医生列表
export function docList (data) {
  return request({
    url: '/wx/mine/doctorInfo/list',
    method: 'get',
    params: data
  })
}

// 获取医生7天排班信息
export function getClassesInfoByUserId (data) {
  return request({
    url: '/wx/doctor/getClassesInfoByUserId/' + data,
    method: 'get'
  })
}

// 获取部门医生列表
export function getDoctorInfoByDeptCode (data) {
  return request({
    url: '/wx/wxSectionDoctor/getDoctorInfoByDeptCode/' + data,
    method: 'get'
  })
}

//获取诊室列表 data = { admDate,deptCode}
export function getRoomList (data) {
  console.log(data)
  return request({
    url: `wx/wxSectionDoctor/getClinicRoomNo/${data.admDate}/${data.deptCode}`,
    method: 'get'
  })
}

export function EpRecords (data) {
  return request({
    url: `/wx/mine/addEpRecords`,
    method: 'post',
    data: data
  })
}

// 获取未缴费处方列表
export function getUnExtFeeList (query) {
  return request({
    url: `/wx/order/getUnExtFeeList`,
    method: 'get',
    params: query
  })
}
// 获取已缴费处方列表
export function getExtFeeList (query) {
  return request({
    url: `/wx/order/getExtFeeList`,
    method: 'get',
    params: query
  })
}

export function getExtFeeDetail (query) {
  return request({
    url: `/wx/order/getExtFeeDetail`,
    method: 'get',
    params: query
  })
}

export function changePatientPhone (query) {
  return request({
    url: `/wx/order/updatePatientPhone`,
    method: 'get',
    params: query
  })
}


export function getPayOrderList (query) {
  return request({
    url: `/wx/order/getPayOrderList`,
    method: 'get',
    params: query
  })
}

// 获取挂号票据信息
export function getGHPTrigger (query) {
  return request({
    url: `/wx/manual/gh/pTrigger`,
    method: 'get',
    params: query
  })
}
// 获取门诊票据信息
export function getMZPTrigger (data) {
  return request({
    url: `/wx/manual/mz/mz_pTrigger`,
    method: 'post',
    data: data
  })
}
// 获取pacs报告信息
export function getPacsList (query) {
  return request({
    url: `/wx/getPacsResult`,
    method: 'get',
    params: query
  })
}
// 获取lis报告列表
export function getLisList (query) {
  return request({
    url: `/wx/getLisResult`,
    method: 'get',
    params: query
  })
}
// 获取lis报告详情
export function getLisDetail (query) {
  return request({
    url: `/wx/getLisDetailResult`,
    method: 'get',
    params: query
  })
}

